const hasNumber = (value: string) => /\d{1}/.test(value);

export default hasNumber;
